import { createSelector } from '@reduxjs/toolkit';
import { IntervalsListState } from 'ducks/intervals-list/slices';
import { RootState } from 'store';

const intervalsListSlice = (state: RootState) => state.intervals_list;

export const selectIntervalsList = createSelector([intervalsListSlice], (state): IntervalsListState => state);
